
import { locale } from './globals.js';
import { loadJSON } from './toolbox.js';

const monthSeparator = function (date) {
  return `<li class="event-month-divider">${date}</li>`
}
const eventThumb = function (event) {
  return `
    <li> <a href="${event.url}" class="event-thumb box landscape" data-fancybox="events" data-type="ajax">
      <div class="box-thumb"> <div class="day">${event.date.day}</div> <div class="month">${event.date.month}</div> </div>
      <div class="box-cover"> <figure class="cover aspect-ratio wide hover-zoom" style="background-image:url('${event.thumb}')"></figure> </div>
      <div class="box-content"> <div class="wrap"> <h3 class="box-title">${event.title}</h3> </div> </div>
    </a> </li>
    `
}
const emptyThumb = function (msg) {
  return `
    <li class="no-events">${msg}</li>
    `
}
class EventsLoader {
  constructor (el) {
    if(!el) return false;
    this.el = el;
    this.list = document.querySelector('[data-events-list]');
    this.api = this.el.getAttribute('data-api');
    this.date = this.el.getAttribute('data-date');
    this.el.addEventListener('click', () => {
      this.el.setAttribute('data-state', 'working');
      let url = this.api.replace('%date%', this.date);
      loadJSON(url, this.renderEvents.bind(this), (resp) => {
        this.el.setAttribute('disabled', 'disabled');
        this.el.setAttribute('data-state', 'error');
      });
    })
  }
  renderEvents (data) {
    data = JSON.parse(data);
    let msg = '';
    let dom = '';
    dom += monthSeparator(data['date']);
    if (data.events && data.events.length > 0) {
      data.events.forEach(event => {
        dom += eventThumb(event);
      });
    } else {
      msg = data.msg ? data.msg : 'No events this month';
      dom += emptyThumb(msg);
    }
    requestAnimationFrame(() => {
      this.list.innerHTML += dom;
      this.bumpDate();
      this.el.setAttribute('data-state', 'ready');
    })
  }
  bumpDate() {
    let month = parseInt(this.date.split('-')[1]);
    let year =  parseInt(this.date.split('-')[0]);
    let nextDate = '';
    if (month < 9) {
      nextDate = `${year}-0${month+1}`;
    } else if ( month >= 9 && month < 12) {
      nextDate = `${year}-${month+1}`;
    } else {
      nextDate = `${year+1}-01`;
    }
    this.date = nextDate;
    this.el.setAttribute('data-date', this.date);
  }
  
}
export default function () {
  new EventsLoader(document.querySelector('[data-events-loader]'));
}
